import React from 'react'

import Icon from '@/legacy-src/components/icons/Icon'
import { type TherapistCategoryType } from '@/legacy-src/hooks/useTherapistCategories'

type Props = { category?: TherapistCategoryType }

const TherapistCategory: React.FC<Props> = ({ category }) => {
  if (!category) return null
  return (
    <div className="flex items-center gap-2 text-sm font-bold">
      <Icon icon="briefcase" />
      <div>
        {category.name}
        {category.description && <div className="font-normal">{category.description}</div>}
      </div>
    </div>
  )
}

export default TherapistCategory
